<script lang="ts">
  import type { Bootcamp } from "$lib/datamodel";
  import FollowBootcamp from "./modals/FollowBootcamp.svelte";
  import SelectBootcamp from "./modals/SelectBootcamp.svelte";
  import { inview } from 'svelte-inview';
  import { popup } from "$lib/client/stores/nucamp-popup";
  import { currentBootcamp } from "$lib/client/stores/nucamp-currentbootcamp";
  import type { ContactCaptureSchema } from "./forms/CaptureContact.svelte";
  import type { Infer, SuperValidated } from "sveltekit-superforms";
  import { page } from "$app/stores";
  export let bootcamps: Bootcamp[];
  export let supForm: SuperValidated<Infer<ContactCaptureSchema>>;
  
  let openSelectBootcamp = false;
  let openFollowBootcamp = false;
  let hasBeenOpened: {timer: boolean, scroll: boolean} = {timer: false, scroll: false};

  $: if ($page.url) {
    hasBeenOpened.scroll = false;
    hasBeenOpened.timer = false;
  }

  function onOpenSelectBootcamp(data:any) {
    openSelectBootcamp = data;
  }

  function onOpenFollowBootcamp(data:any) {
    openFollowBootcamp = data;
  }
  
  export let openPopUp = (type: string, force = false) => {
    if (type === 'timer') {
      if (!hasBeenOpened.timer && !hasBeenOpened.scroll) {
        if (!$currentBootcamp?.id) openSelectBootcamp = true;
        else openFollowBootcamp = true;
        hasBeenOpened.timer = true;
      }
    } else if (type === 'scroll') {
      if (!hasBeenOpened.scroll || force) {
        if (!$currentBootcamp?.id) openSelectBootcamp = true;
        else openFollowBootcamp = true;
        hasBeenOpened.scroll = true;
      }
    }
  }
  
  const timeOutId = setTimeout(() => {
    openPopUp("timer");
  }, 10000);
  popup.update((p) => ({...p, timerId: timeOutId}));

</script>


<div use:inview={{}} on:inview_enter={() => openPopUp("scroll")}>
  <SelectBootcamp open={openSelectBootcamp} bind:openFollowBootcamp onOpenChange={onOpenSelectBootcamp} {bootcamps}></SelectBootcamp>
  <FollowBootcamp open={openFollowBootcamp} {supForm} onOpenChange={onOpenFollowBootcamp}></FollowBootcamp>
</div>
